import { NavMarker } from 'react-rhumb';
import { Redirect, Route, Switch } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Header as FoundationsHeader, HeaderDetails } from 'foundations-components/transitional/components/Header';
import { Link } from 'foundations-components/transitional/components/Link';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { View } from 'foundations-components/components/View';
import { makeAsyncComponent } from 'page-lib/utils/makeAsyncUtils';
import useQueryParams from '../../hooks/useQueryParams';
import { useAppSelector } from '../../reducers';
import { selectAuthState } from '../../selectors';
import OptimizationSidebar from '../OptimizationSidebar';
import ExternalPageHeaderUrlPreviewScreenshot from './ExternalPagePreviewImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncInternalLinksContainer = makeAsyncComponent(() => import( /* webpackChunkName: "InternalLinksContainer" */'content-intel-content-details-optimize-panel/components/internalLinks/InternalLinks'));
const AsyncKeywordContainer = makeAsyncComponent(() => import( /* webpackChunkName: "KeywordSection" */'content-intel-content-details-optimize-panel/components/searchQueries/SearchQueries'));
const Header = ({
  title,
  url
}) => {
  return /*#__PURE__*/_jsx(FoundationsHeader, {
    breadcrumbs: /*#__PURE__*/_jsx(Breadcrumbs, {
      children: /*#__PURE__*/_jsx(Link, {
        href: `/analytics/${PortalIdParser.get()}/pages`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.header.backBreadcrumb"
        })
      })
    }),
    details: /*#__PURE__*/_jsx(HeaderDetails, {
      leftContent: /*#__PURE__*/_jsx(ExternalPageHeaderUrlPreviewScreenshot, {
        title: title,
        url: url
      }),
      rightContent: /*#__PURE__*/_jsx(View, {
        maxInlineSize: "33vw",
        children: /*#__PURE__*/_jsxs(DescriptionList, {
          children: [/*#__PURE__*/_jsx("dt", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "page-details-ui.header.titles.url"
            })
          }), /*#__PURE__*/_jsx("dd", {
            children: /*#__PURE__*/_jsx(Link, {
              external: true,
              href: url,
              children: url
            })
          })]
        })
      })
    }),
    title: title
  });
};
const ExternalPageDetailsPage = ({
  title,
  url
}) => {
  const auth = useAppSelector(selectAuthState);
  const queryParams = useQueryParams();
  const queryParamsString = queryParams.toString();
  return /*#__PURE__*/_jsx(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(Header, {
      title: title,
      url: url
    }),
    sidebarComponent: /*#__PURE__*/_jsx(OptimizationSidebar, {
      contentUrl: url
    }),
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        render: () => /*#__PURE__*/_jsx(AsyncKeywordContainer, {
          renderNavMarker: () => /*#__PURE__*/_jsx(NavMarker, {
            name: "OPTIMIZATION_KEYWORD_LOADED"
          }),
          url: url
        }),
        path: "/external-page/optimization/queries"
      }), /*#__PURE__*/_jsx(Route, {
        render: () => /*#__PURE__*/_jsx(AsyncInternalLinksContainer, {
          auth: auth,
          renderNavMarker: () => /*#__PURE__*/_jsx(NavMarker, {
            name: "OPTIMIZATION_INTERNAL_LINKS_LOADED"
          }),
          url: url
        }),
        path: "/external-page/optimization/internalLinks"
      }), /*#__PURE__*/_jsx(Redirect, {
        to: {
          pathname: '/external-page/optimization/queries',
          search: queryParamsString
        }
      })]
    })
  });
};
export default ExternalPageDetailsPage;